export default function(){return Promise.resolve({allowed:!0,valid:!0})}